import { render, staticRenderFns } from "./group-form.vue?vue&type=template&id=a25ac340&scoped=true&lang=pug&"
import script from "./group-form.vue?vue&type=script&lang=ts&"
export * from "./group-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a25ac340",
  null
  
)

export default component.exports